import React, {Component} from "react";
import "./CartItemDelete.css";
import {FormattedMessage} from "react-intl";
import {Modal} from "react-bootstrap";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../configuration";

class CartAllItemsDelete extends Component {

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            userId: "1"
        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    handleClose = () => {
        this.setState({show: false});
    };

    handleShow = () => {
        this.setState({show: true});
    };

    deleteAllCartItems = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.delete(RESOURCE_BASE_URL + 'api/users/' + this.props.userId + '/cart', axiosConfig)
            .then((res) => {
                // console.log("all items successfully deleted", res);
                this.props.getCartItems();
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });

    };

    onSubmit = event => {

        event.preventDefault();
        this.deleteAllCartItems();
        this.handleClose();
    };

    render() {

        return (
            <span>

                <a className="empty-cart-link" onClick={this.handleShow}>
                    <FormattedMessage id="app.cart.empty-cart-link"
                                      defaultMessage="Empty Cart "
                                      description=""/>
                    </a>

                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            <FormattedMessage id="app.cart-item-delete-all.title"
                                              defaultMessage="DELETE ALL ITEMS"
                                              description=""/>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <FormattedMessage id="app.cart-item-delete-all.message"
                                              defaultMessage="Are you sure you want to delete all the items from the cart ?"
                                              description=""/>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <div className="delete-cart-item-div">
                        <button className="btn btn-primary bottom-button" onClick={this.onSubmit}>
                            <FormattedMessage id="app.cart-item-delete-all.yes"
                                              defaultMessage="Yes"
                                              description=""/>
                        </button>
                        <button className="btn btn-default bottom-button" onClick={this.handleClose}>
                            <FormattedMessage id="app.cart-item-delete-all.no"
                                              defaultMessage="No"
                                              description=""/>
                        </button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </span>
        );
    }
}

export default CartAllItemsDelete;



// WEBPACK FOOTER //
// ./src/components/Site/Cart/CartItemDelete/CartAllItemsDelete.js